import { EnglishLevelTest } from "../lib/english_level_test";

const initEnglishLevelTest = () => {
  document.querySelectorAll("[data-english-level-test]").forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "true";
    const test = new EnglishLevelTest(JSON.parse(root.querySelector("[data-test-bank]").textContent));
    const start = root.querySelector("[data-test-start]");
    const quiz = root.querySelector("[data-test-quiz]");
    const form = root.querySelector("[data-test-form]");
    const prompt = root.querySelector("[data-test-prompt]");
    const passage = root.querySelector("[data-test-passage]");
    const options = root.querySelector("[data-test-options]");
    const next = root.querySelector("[data-test-next]");
    const progress = root.querySelector("[data-test-progress]");
    start.hidden = false;

    const render = () => {
      progress.value = test.result ? 15 : test.answered;
      if (test.result) {
        quiz.hidden = true;
        const result = root.querySelector(`[data-test-result="${test.result}"]`);
        result.hidden = false;
        result.querySelector("h2").focus();
        return;
      }
      const question = test.question;
      prompt.textContent = question.prompt;
      passage.textContent = question.passage || "";
      passage.hidden = !question.passage;
      options.replaceChildren();
      question.options.forEach((text, index) => {
        const label = document.createElement("label");
        label.className = "flex items-start gap-3 rounded-xl border border-stone-300 p-4 cursor-pointer";
        const input = document.createElement("input");
        input.type = "radio";
        input.name = "answer";
        input.value = index;
        input.required = true;
        input.className = "mt-1";
        label.append(input, document.createTextNode(text));
        options.append(label);
      });
      next.disabled = true;
      prompt.focus();
    };
    start.addEventListener("click", () => {
      start.hidden = true;
      quiz.hidden = false;
      render();
    });
    form.addEventListener("change", () => { next.disabled = false; });
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const selected = form.querySelector("input:checked");
      if (!selected || next.disabled) return;
      next.disabled = true;
      test.answer(Number(selected.value));
      render();
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initEnglishLevelTest);
} else {
  initEnglishLevelTest();
}
document.addEventListener("turbo:load", initEnglishLevelTest);
// Turbo caches DOM but not listeners. Restore a clean initial state for Back.
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("[data-english-level-test]").forEach((root) => {
    const clean = root.cloneNode(true);
    delete clean.dataset.initialized;
    clean.querySelector("[data-test-start]").hidden = true;
    clean.querySelector("[data-test-quiz]").hidden = true;
    clean.querySelectorAll("[data-test-result]").forEach((result) => { result.hidden = true; });
    root.replaceWith(clean);
  });
});
